import React from "react";
import { Row, Col, Typography } from "antd";
import "../App.css";
import AuthPanel from "./AuthPanel";
import SubscriptionForm from "./Subscription";
import { CheckCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const HeroSection = () => {
  return (
    <div className="hero-section">
      <div className="hero-container">
      <div class="hero-background-shapes">
  <div class="diamond-right"></div>
  <div class="circle-left"></div>
  <div class="diamond-left"></div>


</div>
      <h1 class="hero-title">
    Turn Your Talent Pool Into <span class="gradient-word">Your Primary Source of Hires</span>
</h1>

        <div className="hero-description" style={{ fontSize: '20px', lineHeight: '1.6', maxWidth: '800px' }}>
          <p style={{ marginTop: '-20px', fontWeight: '500', color: '#333', fontSize: '24px' }}>
            Instantly match and engage candidates from your talent pool for every role.
          </p>
        </div>
        {/* Add 14-day free trial and no credit card required */}
       

        {/* 7-day Free Trial and No Credit Card Required */}
        <Row 
          gutter={[24, 16]} 
          style={{ marginTop: 20, textAlign: 'center', marginBottom: 35 }} 
        >
          <Col xs={24} sm={12} className="trial-column">
            <div className="trial-content">
              <CheckCircleOutlined style={{ color: 'green', marginRight: 8, fontSize: '24px' }} />
              <Text style={{ fontSize: '22px', fontWeight: '600' }}>7-Day Free Trial</Text>
            </div>
          </Col>
          <Col xs={24} sm={12} className="trial-column">
            <div className="trial-content">
              <CheckCircleOutlined style={{ color: 'green', marginRight: 8, fontSize: '24px' }} />
              <Text style={{ fontSize: '22px', fontWeight: '600' }}>No Credit Card Required</Text>
            </div>
          </Col>
        </Row>

        <div style={{ marginBottom: '40px' }}>
          <AuthPanel />
        </div>
        <div style={{ marginTop: '30px' }}>
          <SubscriptionForm />
        </div>
      </div>
    </div>
  );
  }  

export default HeroSection;
